import { Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthenticationService, UserDetail } from '../services/authentication.service';
import { routesData } from '../models/pages-data';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { BackButtonDirective } from '../helpers/back-button.directive';
import { BreadcrumbComponent } from '../components/breadcrumb/breadcrumb.component';
import { MatDrawerContainer, MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { LoaderComponent } from '../components/loader/loader.component';

@Component({
    selector: 'app-shell',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.scss'],
    imports: [MatToolbar, MatToolbarRow, MatIconButton, MatIcon, MatButton, NgClass, BackButtonDirective, BreadcrumbComponent, MatDrawerContainer, MatDrawer, MatNavList, MatListItem, RouterLink, RouterLinkActive, MatDrawerContent, RouterOutlet, LoaderComponent]
})
export class ShellComponent implements OnInit {

    private destroyRef = inject(DestroyRef);

    show = true;
    isMobile = false;

    loading = false;
    user: UserDetail | null;
    routesData;
    isHome = false;
    currentRoute: string;

    constructor(private authenticationService: AuthenticationService,
        private router: Router) {
        this.routesData = routesData;
        this.currentRoute = "";
        this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentRoute = event.url;
                this.isHome = this.currentRoute === '/home' || this.currentRoute === '/';
            }
        });
    }

    ngOnInit() {
        this.syncViewportState();
        this.authenticationService.currentUser$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(x => {
            this.user = x;
        });
    }

    hideSidenav() {
        this.show = !this.show;
    }

    closeSidenavOnMobile(): void {
        if (this.isMobile) {
            this.show = false;
        }
    }

    private syncViewportState(): void {
        const mobile = window.matchMedia('(max-width: 768px)').matches;
        if (mobile !== this.isMobile) {
            this.isMobile = mobile;
            this.show = !mobile;
        }
    }

    @HostListener('window:resize')
    onResize(): void {
        this.syncViewportState();
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
        window.location.reload();
    }

}

